const {
  VITE_APP_LIW_INTEGRATION_SCRIPT_URL,
  VITE_APP_BASE_API_URL,
  VITE_APP_SENTRY_DSN,
  VITE_APP_ERROR_TRACKER_ACTIVE
} = import.meta.env;

export default {
  baseApiUrl: VITE_APP_BASE_API_URL,
  liwGamesScriptUrl: VITE_APP_LIW_INTEGRATION_SCRIPT_URL,
  sentryDsn: VITE_APP_SENTRY_DSN,
  errorTrackerActive: VITE_APP_ERROR_TRACKER_ACTIVE
};
